// src/components/FloatingTimer.jsx
import React from "react";
import { Box, Typography } from "@mui/material";
import { useAutoLogout } from "app/contexts/AutoLogoutProvider";

const FloatingTimer = () => {
  const { minutes, seconds } = useAutoLogout();

  if (minutes >= 2) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 16,
        right: 16,
        backgroundColor: "error.main",
        color: "white",
        px: 2,
        py: 1,
        borderRadius: 2,
        boxShadow: 3,
        zIndex: 1500,
      }}
    >
      <Typography variant="body2" fontWeight="bold">
        Auto logout in: {minutes}:{String(seconds).padStart(2, "0")}
      </Typography>
    </Box>
  );
};

export default FloatingTimer;
